<template>
  <v-row justify="center">
    <v-col cols="12" sm="10" md="8" lg="6" xl="6">
      <v-container class="py-5">
        <v-card class="card py-5 my-3">
          <v-img
            src="@/assets/img/company-logo/TFF_StackedLogo_BIL.png"
            alt="Terry Fox Foundation logo"
            contain
            height="100"
            class="mb-5"
          ></v-img>

          <!-- <div placeholder="{{ 'Form Not Found' | translate }}"></div> -->
          <h3 class="text-center mb-3">
            {{ $t(["Form Not Found"]) }}
          </h3>

          <!-- <div placeholder="{{ 'Invalid form URL. Please ask TFF volunteer to have form URL resent to you.' | translate }}"></div> -->
          <p class="px-5 mb-0" align="center">
            {{
              $t([
                "Invalid form URL. Please ask TFF volunteer to have form URL resent to you",
              ])
            }}
          </p>
        </v-card>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FormNotFound",
  data: () => {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
